"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _noop = _interopRequireDefault(require("lodash/noop"));

var _enums = require("@guestyci/foundation/enums/enums");

var _ClickOutsideListener = _interopRequireDefault(require("@guestyci/foundation/ClickOutsideListener"));

var _Menu = _interopRequireDefault(require("../Menu/Menu"));

var _MenuAutoPosition = _interopRequireDefault(require("../Menu/MenuAutoPosition"));

var _InfiniteScroll = _interopRequireDefault(require("../InfiniteScroll/InfiniteScroll"));

var _TextField = _interopRequireDefault(require("../TextField/TextField"));

var DropdownMenu = function DropdownMenu(_ref) {
  var topBar = _ref.topBar,
      isCollapsed = _ref.isCollapsed,
      className = _ref.className,
      isEmptyState = _ref.isEmptyState,
      children = _ref.children,
      onDismiss = _ref.onDismiss,
      onLoadMore = _ref.onLoadMore,
      isFetching = _ref.isFetching,
      pageCount = _ref.pageCount,
      menuClassName = _ref.menuClassName,
      scrollHeight = _ref.scrollHeight,
      currentPage = _ref.currentPage,
      anchorDirection = _ref.anchorDirection,
      emptyStateComponent = _ref.emptyStateComponent;
  return /*#__PURE__*/_react["default"].createElement(_MenuAutoPosition["default"], {
    className: (0, _classnames["default"])('nowrap', className),
    trigger: !isCollapsed,
    anchorDirection: anchorDirection,
    "data-qa": "dropdown-menu"
  }, /*#__PURE__*/_react["default"].createElement(_ClickOutsideListener["default"], {
    onClickOutside: onDismiss
  }, /*#__PURE__*/_react["default"].createElement(_Menu["default"], {
    className: "bg-white overflow-y-hidden",
    dense: true,
    collapse: isCollapsed
  }, topBar, /*#__PURE__*/_react["default"].createElement(_Menu["default"], {
    dense: true,
    maxHeight: scrollHeight,
    className: menuClassName
  }, /*#__PURE__*/_react["default"].createElement(_InfiniteScroll["default"], {
    className: "p-4",
    onLoadMore: onLoadMore,
    pageCount: pageCount,
    height: scrollHeight,
    offset: 0,
    initialPage: currentPage,
    isFetching: isFetching
  }, children, isEmptyState && /*#__PURE__*/_react["default"].createElement(_TextField["default"], {
    className: "options-empty"
  }, emptyStateComponent))))));
};

DropdownMenu.defaultProps = {
  topBar: null,
  isCollapsed: true,
  className: '',
  isEmptyState: false,
  onLoadMore: _noop["default"],
  isFetching: false,
  pageCount: 0,
  currentPage: 0,
  scrollHeight: 210,
  anchorDirection: _enums.AnchorDirectionType.Start
};
DropdownMenu.propTypes = {
  topBar: _propTypes["default"].node,
  isEmptyState: _propTypes["default"].bool,
  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node]).isRequired,
  isCollapsed: _propTypes["default"].bool,
  className: _propTypes["default"].string,
  onLoadMore: _propTypes["default"].func,
  onDismiss: _propTypes["default"].func.isRequired,
  pageCount: _propTypes["default"].number,
  isFetching: _propTypes["default"].bool,
  currentPage: _propTypes["default"].number,
  menuClassName: _propTypes["default"].string,
  scrollHeight: _propTypes["default"].oneOf([_propTypes["default"].number, _propTypes["default"].string]),
  anchorDirection: _propTypes["default"].oneOf([_enums.AnchorDirectionType.Center, _enums.AnchorDirectionType.Left, _enums.AnchorDirectionType.Right, _enums.AnchorDirectionType.StartCenter, _enums.AnchorDirectionType.EndCenter, _enums.AnchorDirectionType.Start, _enums.AnchorDirectionType.End])
};
var _default = DropdownMenu;
exports["default"] = _default;